import React from 'react';
import { FragmentType, useFragment } from '@frontend/gql/social';
import { MetricBarChart } from '../../metric-bar-chart';
import { ctrFragment } from '../ctr';

type CtrBarProps = {
  currentInterval: FragmentType<typeof ctrFragment> | null | undefined;
  currentIntervalNotAspireSourced?: FragmentType<typeof ctrFragment> | null | undefined;
  showNonAttributedData?: boolean;
};

export const CtrBar = ({
  currentInterval,
  currentIntervalNotAspireSourced,
  showNonAttributedData = false,
}: CtrBarProps) => {
  const currentIntervalData = useFragment(ctrFragment, currentInterval);
  const currentIntervalNotAspireSourcedData = useFragment(ctrFragment, currentIntervalNotAspireSourced);

  const aspireClicks = currentIntervalData?.totalClicks ?? 0;
  const aspireImpressions = currentIntervalData?.totalImpressions ?? 0;
  const nonAspireClicks = currentIntervalNotAspireSourcedData?.totalClicks ?? 0;
  const nonAspireImpressions = currentIntervalNotAspireSourcedData?.totalImpressions ?? 0;

  const aspireCtr = aspireImpressions > 0 ? (aspireClicks / aspireImpressions) * 100 : 0;
  const nonAspireCtr = nonAspireImpressions > 0 ? (nonAspireClicks / nonAspireImpressions) * 100 : 0;

  if (!showNonAttributedData) {
    return null;
  }

  return (
    <MetricBarChart aspireValue={aspireCtr} nonAspireValue={nonAspireCtr} metricType="percentage" metricName="CTR" />
  );
};
